const conditions = () => {
  return [
    { projectType: { $in: ['object.project-type.options.project-development', 'object.project-type.options.plot'] } },
    {
      assetClass: {
        $in: {
          'object.asset-class.options.wohnen': 'object.building-law-situation.living.options',
          'object.asset-class.options.handel-retail': 'object.building-law-situation.living.options',
          'object.asset-class.options.hotel': 'object.building-law-situation.living.options',
          'object.asset-class.options.healthcare-medical': 'object.building-law-situation.living.options',
          'object.asset-class.options.buero': 'object.building-law-situation.living.options',
          'object.asset-class.options.micro-und-serviced-living': 'object.building-law-situation.living.options',
          'object.asset-class.options.freies-ankaufsprofil': 'object.building-law-situation.living.options',
          'object.asset-class.options.logistik-industrie': 'object.building-law-situation.living.options',
        },
      },
    },
  ]
}

export default conditions
